import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postControlTask } from '../Api'

export default generateApiAction({
  baseType: Types.CTRL_TASKS.POST,
  api: postControlTask,
  responseType: RESPONSETYPE.ID
})



// WEBPACK FOOTER //
// ./src/actions/controlTasks/PostAction.js